import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { IAppState, IFiltersState } from '../../../../common/state';
import { IFeatureToggleState } from '../../../../common/state/types/featureToggle';
import { getTrackingData } from '../../../../selectors/getTrackingData';
import { trackAdFoxMortgage } from '../../../../tracking/adFoxMortgage';
import { ISimplifieldTGBBannerContext } from '../../../../types/adfox';
import { useAdfoxContext } from '../../../../utils/adfox/context';
import { shouldSendAdsEvent as checkShouldSendAdsEvent } from '../../../../utils/shouldSendAdsEvent';
import { NativeTGBAsideInfo } from '../../../components/adfox/templates/tgb_in_card/simplified';
import { isMortgageCampaign } from '../../../components/adfox/utils/mortgage';

export interface IResidentialNativeTGBBannerProps {
  context: ISimplifieldTGBBannerContext;
  locationId: number | undefined;
}

export function ResidentialNativeTGBBanner({ context, locationId }: IResidentialNativeTGBBannerProps) {
  const tracking = useSelector(getTrackingData);
  const { position } = useAdfoxContext();
  const filters = useSelector<IAppState, IFiltersState>(state => state.filters);
  const featureToggle = useSelector<IAppState, IFeatureToggleState>(state => state.featureToggle);

  const shouldSendAdsEvent = React.useMemo(() => {
    return checkShouldSendAdsEvent(filters.jsonQuery) || !featureToggle.isFilterByFlatsEnabled;
  }, [filters.jsonQuery, featureToggle.isFilterByFlatsEnabled]);

  const onTrack = React.useCallback(
    (isShow: boolean) => {
      const { bannerId, campaignId } = context;
      const { user, page } = tracking;

      if (!isMortgageCampaign(campaignId)) {
        return;
      }

      trackAdFoxMortgage(isShow ? 'show' : 'click', 'LinkIpoteka', bannerId, user, page);
    },
    [context, tracking, position, shouldSendAdsEvent, filters.jsonQuery],
  );

  const onView = React.useCallback(() => {
    const { campaignId } = context;

    if (!isMortgageCampaign(campaignId)) {
      return;
    }
  }, [context, position, shouldSendAdsEvent, filters.jsonQuery]);

  return (
    <ActionAfterViewed callback={onView} percentVisible={0.5}>
      <NativeTGBAsideInfo context={context} locationId={locationId} onTrack={onTrack} />
    </ActionAfterViewed>
  );
}
